import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import useModalState from "../../../stores/useModalStore";
import useContactsStore from "../../../stores/useContactsStore";
import {v4 as uuid} from "uuid";
import usePostChangeQuery from "../../../../../global/queries/usePostChangeQuery";
import { Change, status } from "../../../../../global/interfaces/Change";

export default function ConfirmationDialog() {
  const { isConfirmationDialogOpen: isOpen, toggleIsConfirmationDialogOpen } =
    useModalState();
  const { removeContact, currentContact } =
    useContactsStore();

  const query = usePostChangeQuery();

  return (
    <>
      <Dialog
        open={isOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Kontakt Löschen</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Wollen Sie diesen Kontakt löschen?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
                removeContact(currentContact.name || "");
                const change: Change = {
                  datum: new Date().toISOString(),
                  feld: "delete",
                  id: uuid(),
                  name: currentContact.name,
                  status: status.PENDING,
                  suchname: currentContact.suchname,
                  wertAenderung: "",
                  wertOriginal: "",
                };
                query.mutate(change);
                toggleIsConfirmationDialogOpen();
          }} autoFocus variant="contained">
            Ja
          </Button>
          <Button onClick={toggleIsConfirmationDialogOpen} variant="contained">
            Nein
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
